import React from 'react';

export function RankBar({ value, max }) {
  const pct = max > 0 ? Math.round((Number(value) / max) * 100) : 0;
  return (
    <div className="hd-report-rank">
      <span className="hd-report-rank__value">{Number(value).toLocaleString('fr-FR')}</span>
      <div className="hd-report-rank__track" aria-hidden>
        <div className="hd-report-rank__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function formatMonthKey(key) {
  if (!key) return '—';
  const [year, month] = String(key).split('-');
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' });
}

export const PRESCRIPTION_STATUS_LABELS = {
  ACTIVE: 'En cours',
  FULFILLED: 'Délivrée',
  CANCELLED: 'Annulée'
};

export const CONSULTATION_STATUS_LABELS = {
  PENDING: 'En attente',
  COMPLETED: 'Terminée',
  CANCELLED: 'Annulée'
};

export const SERVICE_LINE_LABELS = {
  MEDICAL: 'Médical',
  DENTAL: 'Dentaire',
  NURSING: 'Infirmerie'
};

/** Rôles affichés dans les classements praticiens / prescripteurs. */
export const PRACTITIONER_ROLE_LABELS = {
  doctor: 'Médecin',
  dentist: 'Dentiste',
  nurse: 'Infirmier(ère)',
  major: 'Major',
  'head doctor': 'Médecin chef'
};

export function formatPractitionerLabel(row, { withRole = true } = {}) {
  const name = String(row?.doctor_name || '').trim() || '—';
  if (!withRole) return name;
  const roleLabel = PRACTITIONER_ROLE_LABELS[row?.practitioner_role];
  return roleLabel ? `${name} (${roleLabel})` : name;
}

export const EXAM_STATUS_LABELS = {
  REQUESTED: 'Demandé',
  COMPLETED: 'Réalisé',
  CANCELLED: 'Annulé'
};

export const REST_DAY_STATUS_LABELS = {
  ISSUED: 'Émis',
  CANCELLED: 'Annulé'
};

export function ReportsPanel({ loading, empty, emptyLabel, loadingLabel, children }) {
  return (
    <div className="hd-reports-panel">
      {loading ? (
        <div className="hd-reports-loading">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden />
          <span>{loadingLabel}</span>
        </div>
      ) : empty ? (
        <p className="hd-reports-empty mb-0">{emptyLabel}</p>
      ) : (
        children
      )}
    </div>
  );
}
